var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 40 40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.7 8.6c-2.5-1.2-5.2-2-8.1-2.5-.1 0-.1 0-.1.1-.3.6-.7 1.4-1 2.1-3-.5-6.1-.5-9.1 0-.3-.6-.7-1.4-1-2.1 0 0-.1-.1-.1-.1-2.8.5-5.5 1.3-8.1 2.5 0 0 0 0-.1 0-5.1 7.7-6.5 15.2-5.9 22.6 0 0 0 .1.1.1 3.4 2.5 6.7 4 9.9 5h.1c.8-1 1.4-2.1 2-3.3 0-.1 0-.1-.1-.2-1.1-.4-2.1-.9-3.1-1.5-.1 0-.1-.2 0-.2.2-.2.4-.3.6-.5h.1c6.5 3 13.5 3 19.9 0h.1c.2.2.4.3.6.5.1.1.1.2 0 .2-1 .6-2 1.1-3.1 1.5-.1 0-.1.1-.1.2.6 1.2 1.3 2.3 2 3.3 0 0 .1.1.1 0 3.2-1 6.5-2.5 9.9-5 0 0 0-.1.1-.1 1.2-8.5-1-15.9-5.6-22.6.1.1.1.1 0 0zm-20.3 18.1c-2 0-3.6-1.8-3.6-4s1.6-4 3.6-4 3.6 1.8 3.6 4c0 2.3-1.6 4-3.6 4zm13.2 0c-2 0-3.6-1.8-3.6-4s1.6-4 3.6-4 3.6 1.8 3.6 4c0 2.3-1.6 4-3.6 4z",
    fill: "#fafafa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.13e55dacab4463c43fa5e5e3b9914fd8.svg";
export { ForwardRef as ReactComponent };